var _line, _line2, _circle, _line3, _line4, _circle2, _line5, _line6, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.9104,
    y1: 2.7027,
    x2: 2.9104,
    y2: -0.00000572205,
    stroke: "#2C2C2C",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.9104,
    y1: 20,
    x2: 2.9104,
    y2: 6.48648,
    stroke: "#2C2C2C",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.75,
    cy: 5.4527,
    r: 2.125,
    stroke: "#2C2C2C",
    strokeWidth: 1.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 9.23077,
    y2: -1,
    transform: "matrix(0 -1 -1 0 17.5896 20)",
    stroke: "#2C2C2C",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 7.17948,
    y2: -1,
    transform: "matrix(0 -1 -1 0 17.5896 7.1795)",
    stroke: "#2C2C2C",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.125,
    transform: "matrix(-1 0 0 1 18.75 9.9295)",
    stroke: "#2C2C2C",
    strokeWidth: 1.25
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 3.24324,
    y2: -1,
    transform: "matrix(0 -1 -1 0 9.58966 20)",
    stroke: "#2C2C2C",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 12.973,
    y2: -1,
    transform: "matrix(0 -1 -1 0 9.58966 12.973)",
    stroke: "#2C2C2C",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 2.125,
    transform: "matrix(-1 0 0 1 10.75 14.723)",
    stroke: "#2C2C2C",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filtericon.216bd598a951cebdb761c26610bdca65.svg";
export { ForwardRef as ReactComponent };